// import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";

// import MKBox from "components/MKBox";
// import MKTypography from "components/MKTypography";

// import DefaultNavbar from "examples/Navbars/DefaultNavbar";
// import DefaultFooter from "examples/Footers/DefaultFooter";
// import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

// // Presentation page sections
// import Counters from "pages/Presentation/sections/Counters";
// import Information from "pages/Presentation/sections/Information";
// // import DesignBlocks from "pages/Presentation/sections/DesignBlocks";

// import Testimonials from "pages/Presentation/sections/Testimonials";
// import Download from "pages/Presentation/sections/Download";

// // Presentation page components
// import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// // Routes
// import routes from "routes";
// import footerRoutes from "footer.routes";

// // Images
// import bgImage from "assets/images/bg-presentation.webp";
// import Contact from "pages/LandingPages/Author/sections/Contact";
// import FAQ from "pages/Presentation/sections/FAQ";
// import OfferBanner from "./sections/OfferBanner";
// import LatestWorkCarousel from "./sections/Blogs";
// import breakpoints from "assets/theme/base/breakpoints";
// import { useEffect, useState } from "react";
// import ShowcaseSections from "./sections/ShowcaseSections";


// function Presentation() {

//   const [mobileView, setMobileView] = useState(false);

//   useEffect(() => {
//     function displayMobileNavbar() {
//       if (window.innerWidth < breakpoints.values.lg) {
//         setMobileView(true);
//       } else {
//         setMobileView(false);
//       }
//     }
//     window.addEventListener("resize", displayMobileNavbar);

//     displayMobileNavbar();

//     return () => window.removeEventListener("resize", displayMobileNavbar);
//   }, []);

//   return (
//     <>
//       {/* <MKButton
//         color="info"
//         style={{
//           position: "fixed",
//           zIndex: 9999,
//           top: "47vh",
//           right: "0.5rem",
//         }}
//       >
//         <Icon sx={{ mr: 1 }}>phone</Icon>
//         contact us
//       </MKButton> */}
//       <DefaultNavbar
//         routes={routes}
//         action={{
//           type: "internal",
//           route: "/authentication/sign-in",
//           label: "Sign In",
//           color: "info",
//         }}
//         sticky
//       />
//       <MKBox
//         minHeight={mobileView?"60vh":"97vh"}
//         paddingTop={mobileView?"18rem":"0"}
//         width="100%"
//         sx={{
//           backgroundImage: `url(${bgImage})`,
//           backgroundSize: "contain",
//           backgroundPosition: "top",
//           display: "grid",
//           placeItems: "center",
//         }}
//       >
//         <Container>
//           <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
//             <MKTypography
//               variant="h1"
//               color="white"
//               mt={-6}
//               mb={1}
//               sx={({ breakpoints, typography: { size } }) => ({
//                 [breakpoints.down("md")]: {
//                   fontSize: size["3xl"],
//                 },
//               })}
//             >
//               Book Your Live Artist
//             </MKTypography>
//             <MKTypography
//               variant="body1"
//               color="white"
//               textAlign="center"
//               px={{ xs: 6, lg: 12 }}
//               mt={1}
//             >
//               {/* Turn Moments Into Music. Shows Into Memories */}
//               Make your show by live performance
//             </MKTypography>
//           </Grid>
//         </Container>
//       </MKBox>
//       <Card
//         sx={{
//           p: 2,
//           mx: { xs: 2, lg: 3 },
//           mt: -8,
//           mb: 4,
//           // backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
//           //   rgba(white.main, 0.8),
//           backgroundColor: "white",
//           backdropFilter: "saturate(200%) blur(30px)",
//           boxShadow: ({ boxShadows: { xxl } }) => xxl,
//         }}
//       >
//         <Counters />
//         <OfferBanner />
//         <LatestWorkCarousel />
//         {/* <DesignBlocks /> */}
//         <ShowcaseSections/>
//         <Information />
//         {/* <Pages /> */}
//         <Container sx={{ mt: 6 }}>
//           <BuiltByDevelopers />
//         </Container>
//         <Container>
//           <Grid container spacing={3}>
//             <Grid item xs={12} lg={4}>
//               <FilledInfoCard
//                 variant="gradient"
//                 color="info"
//                 icon="auto_awesome"
//                 title="Curated Talent Selection"
//                 description="Explore a refined collection of premium artists, each verified for quality and professionalism. Find performers who elevate your event’s atmosphere with style and sophistication."
//                 action={{
//                   type: "external",
//                   route: "",
//                   label: "Explore Talent",
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} lg={4}>
//               <FilledInfoCard
//                 color="info"
//                 icon="electric_bolt"
//                 title="Seamless Premium Booking"
//                 description="Enjoy a smooth, concierge-like booking experience. From selection to confirmation, every step is designed for clarity, speed, and comfort."
//                 action={{
//                   type: "external",
//                   route: "",
//                   label: "Experience Ease",
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} lg={4}>
//               <FilledInfoCard
//                 color="info"
//                 icon="festival"
//                 title="Bespoke Event Services"
//                 description="Unlock exclusive event-ready services crafted to complement your vision. Our team supports you with reliable coordination for a flawless, memorable experience."
//                 action={{
//                   type: "external",
//                   route: "",
//                   label: "View Premium Services",
//                 }}
//               />
//             </Grid>
//           </Grid>
//         </Container>
//         <Testimonials />
//         <Download />
//         <FAQ />

//       </Card>
//       <MKBox pt={6} px={1} mt={6}>
//         <Contact />
//         <DefaultFooter content={footerRoutes} />
//       </MKBox>
//     </>
//   );
// }

// export default Presentation;

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

import Counters from "pages/Presentation/sections/Counters";
import Information from "pages/Presentation/sections/Information";
import Testimonials from "pages/Presentation/sections/Testimonials";
import Download from "pages/Presentation/sections/Download";
import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

import routes from "routes";
import footerRoutes from "footer.routes";

import bgImage from "assets/images/bg-presentation.webp";
import Contact from "pages/LandingPages/Author/sections/Contact";
import FAQ from "pages/Presentation/sections/FAQ";
import OfferBanner from "./sections/OfferBanner";
import LatestWorkCarousel from "./sections/Blogs";
import ShowcaseSections from "./sections/ShowcaseSections";

import breakpoints from "assets/theme/base/breakpoints";
import { useEffect, useState } from "react";

// 🌟 Framer Motion Animations
import { motion } from "framer-motion";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const staggerContainer = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.25 },
  },
};

function Presentation() {
  const [mobileView, setMobileView] = useState(false);

  // 🧊 Smooth Navbar Blur on Scroll
  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector("nav");
      if (!nav) return;
      if (window.scrollY > 50) {
        nav.style.background = "rgba(0,0,0,0.6)";
        nav.style.backdropFilter = "blur(12px)";
        nav.style.transition = "all 0.35s ease";
      } else {
        nav.style.background = "transparent";
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const checkView = () =>
      setMobileView(window.innerWidth < breakpoints.values.lg);
    window.addEventListener("resize", checkView);
    checkView();
    return () => window.removeEventListener("resize", checkView);
  }, []);

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/search-artists",
          label: "Search Artists",
          color: "info",
        }}
        sticky
      />

      {/* 🎬 Hero Section - Cinematic Fade */}
      <MKBox
        component={motion.div}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        minHeight={mobileView ? "85vh" : "95vh"}
        paddingTop={mobileView ? "18rem" : "0"}
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={7}
            justifyContent="center"
            mx="auto"
            component={motion.div}
            variants={staggerContainer}
            initial="hidden"
            animate="show"
          >
            <motion.div variants={fadeInUp}>
              <MKTypography variant="h1" color="white" textAlign="center">
                Book Your Live Artist
              </MKTypography>
            </motion.div>

            <motion.div variants={fadeInUp}>
              <MKTypography
                variant="body1"
                color="white"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                Make your show by live performance
              </MKTypography>
            </motion.div>
          </Grid>
        </Container>
      </MKBox>

      {/* 🌈 Main Content Card */}
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: "white",
          backdropFilter: "saturate(200%) blur(20px)",
        }}
      >
        {/* 🎯 All Sections Animate on View */}
        {[Counters, OfferBanner, LatestWorkCarousel, ShowcaseSections, Information, Testimonials, Download, FAQ].map(
          (Section, i) => (
            <motion.div
              key={i}
              variants={fadeInUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.1 }}
            >
              <Section />
            </motion.div>
          )
        )}

        {/* ⭐ Premium Feature Cards */}
        <Container
          sx={{ mt: 6 }}
          component={motion.div}
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <BuiltByDevelopers />

          <Grid container spacing={3} mt={2}>
            {[
              {
                title: "Curated Talent Selection",
                desc: "Explore a refined collection of premium artists...",
                icon: "auto_awesome",
              },
              {
                title: "Seamless Premium Booking",
                desc: "Enjoy a smooth, concierge-like booking experience...",
                icon: "electric_bolt",
              },
              {
                title: "Bespoke Event Services",
                desc: "Unlock exclusive event-ready services...",
                icon: "festival",
              },
            ].map((card, i) => (
              <Grid item xs={12} lg={4} key={i}>
                <motion.div
                  variants={fadeInUp}
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 180 }}
                >
                  <FilledInfoCard
                    color="info"
                    icon={card.icon}
                    title={card.title}
                    description={card.desc}
                    action={{
                      type: "external",
                      route: "",
                      label: "Learn More",
                    }}
                  />
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Card>

      <MKBox pt={6} px={1} mt={6}>
        <motion.div
          variants={fadeInUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <Contact />
        </motion.div>

        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;

